import React from "react";
import styled from "styled-components";
import { ProcessProps } from "Data/about";
import TextParagraph from "Components/Text/TextParagraph";
import media from "Styles/media";
import Indecator from "Components/Indecator";
import useSliderCount from "Hooks/useSliderCount";
const Wrapper = styled.div``;

const ProcessWrapper = styled.ul`
	@media ${media.mobile} {
		display: flex;
		position: relative;
		width: 100%;
		overflow: scroll;
		scroll-snap-type: x mandatory;
		${(props) => props.theme.layout.scroll_hide};
		scroll-behavior: smooth;
	}
`;

const TypeRow = styled.li`
	display: flex;
	@media ${media.mobile} {
		flex-direction: column;
		width: 100%;
		flex-shrink: 0;
		flex-grow: 0;
		scroll-snap-align: center;
	}
`;

const TypeText = styled(TextParagraph)`
	opacity: 1;
	width: 140px;
	flex-shrink: 0;
	@media ${media.mobile} {
		width: initial;
	}
`;

const Contents = styled.div`
	border-left: 1px solid ${(props) => props.theme.color.white};
	padding-left: 32px;
	flex-grow: 1;
	@media ${media.mobile} {
		border-top: 1px solid ${(props) => props.theme.color.white};
		padding-left: 0;
		border-left: none;
		padding-top: ${(props) => `${props.theme.size.offset.tablet}px`};
	}
`;

const ContentsRow = styled.div`
	display: flex;
	margin-bottom: 24px;

	@media ${media.mobile} {
		margin-bottom: 8px;
		flex-direction: column;
	}
`;
const NameText = styled(TextParagraph)`
	width: 30%;
	opacity: 1;
	min-width: 200px;
	@media ${media.mobile} {
		width: 100%;
	}
`;
const TitleText = styled(TextParagraph)`
	width: 70%;
`;

const LocalIndecator = styled(Indecator)`
	display: none;
	@media ${media.mobile} {
		display: block;
	}
`;
const AboutProcess: React.FC<{ data: ProcessProps[] }> = ({ data }) => {
	const { slider, count, indecatorClicked } = useSliderCount();
	return (
		<Wrapper>
			<ProcessWrapper ref={slider}>
				{data.map((el, index) => {
					return (
						<TypeRow key={index}>
							<TypeText value={`#${index + 1 < 10 && `0`}${index + 1} ${el.type}`} bold={true} />
							<Contents>
								{el.contents.map((cts, i) => {
									return (
										<ContentsRow key={i}>
											<NameText value={cts.name} />
											<TitleText value={cts.title} />
										</ContentsRow>
									);
								})}
							</Contents>
						</TypeRow>
					);
				})}
			</ProcessWrapper>
			<LocalIndecator count={data.length} nowCount={count} onClick={indecatorClicked} />
		</Wrapper>
	);
};

export default AboutProcess;
